<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
   <!-- ここに結果を表示 -->
   
   <h2 class="vy-kojin-title">{{ title }}</h2>
     <article style="padding:0 10px">
            <hr>
            <!-- パンくずリスト -->
            <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" >
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
                    <li class="breadcrumb-item"><a href="#" v-on:click="Return_list">体験プログラム一覧</a></li>
                    <li class="breadcrumb-item"><a href="#" v-on:click="Return_detail">体験プログラム詳細</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
                </ol>
            </nav>
            <div id="manual_area">

              <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験ユーザーのマニュアル</span>
              <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

            </div>

            <br clear="all">
      <div id="tab">
        
           
        <ul class="tabMenu">
           <li @click="TabChange('tab1')" id="tab1" v-bind:class="tab1" style="border:0;border-bottom:1px solid #007db9;">未チェックイン</li>
           <li @click="TabChange('tab2')" id="tab2" v-bind:class="tab2" style="border:0;border-bottom:1px solid #007db9;">チェックイン済</li>
        </ul>
        <div style="
            width: 98%;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            align-items: center;">
          <div >
          </div>
        <b style="display: flex;
                  justify-content: space-evenly;
                  flex-direction: column;
                  align-items: flex-end;
                  font-size: 18px;
                  padding:10px 0;">{{kensu}} / {{ all_kensu }} 件</b>
        </div>
        <div v-if="kensu > 0">
          <div id="blank_area" style="float:left;width:0px;height:50px;"></div>
           <button v-if="TabActive=='tab1'" class="btn mx-aut btn-secondary" style="width: 180px; height: 50px;padding: 0;" v-on:click.prevent.stop="Checkin_check()">チェックイン代行</button>
            <button v-else class="btn mx-aut btn-secondary" style="width: 180px; height: 50px;padding: 0;" v-on:click.prevent.stop="Checkin_check()">未チェックイン</button>
        </div>
        <div v-if="kensu > 0"  id="page_area" style="display: flex;justify-content: space-between;">
          <div v-if="!isSP" id="kensu_area" style="width:150px;">
          </div>
          <div style="width:80%;display: flex;justify-content: center;align-items: center;margin:0 auto">
                <div style="float:left;cursor:pointer" v-on:click="top"><span v-if="!isSP">最初へ</span><span v-if="isSP">最初</span>&nbsp;&nbsp;</div>
                <div style="float:left;cursor:pointer" v-on:click="back"><span v-if="!isSP">前へ</span><span v-if="isSP">前</span>&nbsp;&nbsp;</div>
                <div v-for="i in getPageList" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
                <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;<span v-if="!isSP">次へ</span><span v-if="isSP">次</span></div>
                <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;<span v-if="!isSP">最後へ</span><span v-if="isSP">最後</span></div>
            </div>
            <div id="kensu_area" style="width:150px;">
                <span v-if="!isSP">表示件数：</span><span v-if="isSP">件数：</span>
              <select class="Change_count" name="Change_count" v-model="page_read_count" v-on:change="Count_change">
                <option value="10" selected>10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </div>
          </div>

        <!-- PCの場合 -->  
        <div v-if="!isSP">

        <div class="vy-search-result-row-head" style="width:98%;margin:auto">
          <div class="vy-search-result-column-kojin-head-name" style="flex:0.5">
            <input type="checkbox" class="form-check-input" v-model="all_check" :onclick="all_user_check" style="width:17px;height:17px">
          </div>
              <!--
               並び替え項目配列
                {"username_kana":"▲","gakko_name":"▲","program_kbn":"▲","program_name":"▲","jisseki.kaisai_date":"▲","tel":"▲","checkin_date":"▲"} 
              -->
           <div class="vy-search-result-column-kojin-head-name" style="width:20%">
            氏名
            <span class="sort_button">
              <a href="#" v-on:click.prevent.stop="Sort('username_kana')">{{ order_list["username_kana"] }}</a>
            </span>
          </div>
          <div class="vy-search-result-column-kojin-head-ins" style="width:18%">
            学校名
            <span class="sort_button">
              <a href="#" v-on:click.prevent.stop="Sort('gakko_name')">{{ order_list["gakko_name"] }}</a>
            </span>
          </div>
          <div class="vy-search-result-column-kojin-head-exp" style="width:10%">
            種類
            <span class="sort_button">
              <a href="#" v-on:click.prevent.stop="Sort('program_kbn')">{{ order_list["program_kbn"] }}</a>
            </span>
          </div>
          <div class="vy-search-result-column-kojin-head-exp" style="width:23%">
            プログラム・説明会・集会名
            <span class="sort_button">
              <a href="#" v-on:click.prevent.stop="Sort('program_name')">{{ order_list["program_name"] }}</a>
            </span>
          </div>
          <div class="vy-search-result-column-kojin-head-exp" style="width:13.5%">
            開催日(参加日)
            <span class="sort_button">
              <a href="#" v-on:click.prevent.stop="Sort('jisseki.kaisai_date')">{{ order_list["jisseki.kaisai_date"] }}</a>
            </span>
          </div>
          
          <div class="vy-search-result-column-kojin-head-ins" style="width:15.5%">

            <span v-if="TabActive == 'tab2'">
                チェックイン
              <span class="sort_button">
                <a href="#" v-on:click.prevent.stop="Sort('checkin_date')">{{ order_list["checkin_date"] }}</a>
              </span>
            </span>
            <span v-else>
              電話番号
              <span class="sort_button">
                <a href="#" v-on:click.prevent.stop="Sort('usertel1')">{{ order_list["usertel1"] }}</a>
              </span>
            </span>
           
          </div>
        </div>

        <div class="vy-search-result" style="width:98%;margin:auto auto 10px auto;">
          <!--
          <div v-for="(result) in display_results" v-bind:key="result.taikenuser_id" class="vy-search-result-row">-->
          <!--<div v-for="(katsu,i) in katsudo.slice(st-1,ed-1)" v-bind:key="i">-->
          <div v-for="(result,i) in disp_results" v-bind:key="i" class="vy-search-result-row">
            
            <div class="vy-search-result-row-a">
              <!-- チェックイン用チェックボックス -->
              <div class="vy-search-result-column-kojin-age" style="flex:0.5">
                <input type="checkbox" class="form-check-input" v-model="user_check" v-bind:value="result.jisseki_id" style="margin:0;width:17px;height:17px">
              </div>
              <!-- 氏名 -->
              <div class="vy-search-result-column-kojin-name" style="width:20%">
                {{result.username}}
              </div>
              <!-- 学校名 -->
              <div class="vy-search-result-column-kojin-ins" style="width:18%">
                <span v-if="result.gakko_name != 'None'">{{result.gakko_name}}</span>
              </div>
              <!-- 種類 -->
              <div class="vy-search-result-column-kojin-exp" style="width:10%">
                体験プログラム
            
              </div>
              <!-- プログラム・説明会・集会名 -->
              <div class="vy-search-result-column-kojin-exp" style="width:23%">
                
                <span v-if="result.program_kbn==2">{{ result.jizen_name }}</span>
                <span v-else-if="result.program_kbn==3">{{ result.jigo_name }}</span>
                <span v-else>{{ result.name }}</span>
            
              </div>
              <!-- 開催日(参加日) -->
              <div class="vy-search-result-column-kojin-ins" style="width:13.5%">
                  <span v-if="result.program_kbn == 1 ">
                    <template v-if="result.shubetsu == 1">

                      <span v-if="result.kaisai_date != 'None'">{{KaisaiDate(result.kaisai_date)}}</span>
                    </template>
                    <template v-else>
                      ー
                    </template>
                  </span>
                  <span v-else-if="result.kaisai_date != 'None'">{{KaisaiDate(result.kaisai_date)}}</span>
              </div>
              
              <div class="vy-search-result-column-kojin-ins" style="width:15.5%">
                  <span v-if="TabActive == 'tab2'">
                    <!-- チェックイン -->
                    <span v-if="result.program_kbn == 1 && (result.jokyo == '3' || result.jokyo == '4') ">
                      欠席
                    </span>  
                    <span v-else>
                      {{EuDateTimeSetting(result.checkin_date)}}
                    </span>
                  </span>
                    <!-- 電話番号 -->
                  <span v-else>{{result.usertel1}}</span>
                
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- スマホの場合 -->  
        <table v-if="isSP" style="min-width: 96%;margin-left: 2%;">
          <div v-if="kensu > 0" style="text-align:left;margin-left:10px;margin-bottom: 10px;">
            <input type="checkbox" id="all-check" class="form-check-input" v-model="all_check" :onclick="all_user_check" style="width:17px;height:17px">
            <label for="all-check">全てチェックする</label>
          </div>
          <template v-for="(result,i) in disp_results" v-bind:key="i">
            <tr>
              <!-- 氏名 -->
              <td style="padding:2pt 6pt;background-color:orange;border-bottom: 1px solid #FFF;justify-content: flex-start;align-items: center;">
                <!-- チェックイン用チェックボックス -->
                <div style="display: flex;align-items: center;">
                  <span style="width:10%;text-align:left;">
                    <input type="checkbox" class="form-check-input" v-model="user_check" v-bind:value="result.jisseki_id" style="width:17px;height:17px">
                  </span>
                  <div style="width: 40%;text-align: left;"><b>氏名</b></div>
                  <div style="width: 50%;text-align: left;">
                    {{ result.username }}
                  </div>
                </div>
              </td>
            </tr>  
            <tr>
              <!-- 開催日(参加日) -->
              <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                <div style="display: flex;align-items: center;">
                  <div style="width: 10%;"></div>
                  <div style="width: 40%;text-align: left;"><b>開催日(参加日)</b></div>
                  <span v-if="result.program_kbn == 1 ">
                    <template v-if="result.shubetsu == 1">
                      <span v-if="result.kaisai_date != 'None'">{{KaisaiDate(result.kaisai_date)}}</span>
                    </template>
                    <template v-else>
                      ー
                    </template>
                  </span>
                  <span v-else-if="result.kaisai_date != 'None'">{{KaisaiDate(result.kaisai_date)}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <!-- チェックイン -->
              <td v-if="TabActive == 'tab2'" style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                <div style="display: flex;align-items: center;">
                  <div style="width: 10%;"></div>
                  <div style="width: 40%;text-align: left;"><b>チェックイン</b></div>
                    <span v-if="result.program_kbn == 1 && (result.jokyo == '3' || result.jokyo == '4') ">
                      欠席
                    </span>  
                    <span v-else>
                      {{EuDateTimeSetting(result.checkin_date)}}
                    </span>
                </div>
              </td>
            </tr>
            <tr>
              <!-- 電話番号 -->
              <td style="padding:2pt 6pt;background-color:linen;justify-content: flex-start;align-items: center;" border="1">
                <div style="display: flex;align-items: center;">
                  <div style="width: 10%;"></div>
                  <div style="width: 40%;text-align: left;"><b>電話番号</b></div>
                  <span>{{result.usertel1}}</span>
                </div>
              </td>
            </tr>
            <br>

          </template>
        </table>


        <div v-if="kensu > 0"  id="page_area" style="display: flex;justify-content: space-between;">
         
          <div style="width:80%;display: flex;justify-content: center;align-items: center;margin:0 auto">
                <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
                <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
                <div v-for="i in getPageList" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
                <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
                <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
            </div>
        
        </div>
      </div>
        
    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
              v-bind:message_text="message"
              v-bind:message_cat="message_cat"
              v-bind:message_flag="message_flag"
              @close_message="Close_message"
              @ok_message="OK_message">
    </component>

  </article>
</template>

<script setup>
/* eslint-disable */
import axios from 'axios'
import { ref,watchEffect,computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GlobalData, EuDateTimeSetting, getUser_email } from '../js/userdata_shisetsu.js'
// 子コンポーネントの指定
import MessageModal from './ShisetsuMessageModal.vue'

let URL = GlobalData.$API_URL

const router = useRouter();
const route = useRoute();
const store = useStore()

const emit = defineEmits(['call'])

let title = "チェックイン状況"

const isSP = ref(window.matchMedia("(max-width: 960px)").matches)

// 親コンポーネント（ShakyoUser.vue）から送られてきた値
// param = {'results':results.value,"page":page,"page_read_count":page_read_count}
const props = defineProps(['param']);
  
let TabActive = ref(props.param.TabActive) // どのタブを選択しているか　tab1：未チェックイン、tab2：チェックイン済
let results = props.param.results //情報が全件入った配列
let page_read_count = ref(props.param.page_read_count) //表示件数
let check_page = ref(props.param.page) // 現在のページ数

let read_start = ref(props.param.read_start) //読み始めの位置
read_start.value = parseInt(read_start.value) + (parseInt(page_read_count.value) * (check_page.value - 1))

let end_count = ref(parseInt(page_read_count.value)+1)//読み終わりの位置
end_count.value = parseInt(read_start.value) + parseInt(page_read_count.value);

let tab1 = ref("tabblue")
let tab2 = ref("tabwhite")

let program_id = 0

let non_checkin_list = [] // 未チェックインを格納
let checkin_comp_list = [] // チェックイン済を格納
let disp_results = ref([]) // 実際に表示する配列

let kensu = ref(0) // 未チェックイン・チェックイン済みどちらかの件数
let all_kensu = ref(props.param.all_count) // 未チェックイン・チェックイン済みにかかわらず全体の件数

let all_check = ref(false) // チェックボックス（全て）

let user_check = ref([]) // チェックボックス

let agency_checkin = "" // 代行チェックイン対象の実績id

/* メッセージを表示するモーダルウィンドウ */
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

// 1件でも存在する場合は、全実績の配列から件数を取得し、未チェックインとチェックイン済に分ける
if(results[0]){

  if(results[0].jokyo == 1 ){
    non_checkin_list = results
  }else if(results[0].jokyo == 2){
    checkin_comp_list = results
  }
  kensu.value = results[0].all_count
  disp_results.value = results
  
}


// ソートボタン（左から、氏名、学校名、種類、プログラム名、開催日(参加日)、電話番号（未チェックイン時のみ）、チェックイン日（チェックイン済時のみ））
let order_list = ref({"username_kana":"▲","gakko_name":"▲","program_kbn":"▲","program_name":"▲","jisseki.kaisai_date":"▲","usertel1":"▲","checkin_date":"▲"}) 

// storeに保存された並び替え項目の通りにする
if(store.state.checkin_mode == undefined || store.state.checkin_mode == ''){
  order_list.value = {"username_kana":"▲","gakko_name":"▲","program_kbn":"▲","program_name":"▲","jisseki.kaisai_date":"▲","usertel1":"▲","checkin_date":"▲"}
}else{
  if(store.state.checkin_mode == "ASC"){
    order_list.value = {"username_kana":"▲","gakko_name":"▲","program_kbn":"▲","program_name":"▲","jisseki.kaisai_date":"▲","usertel1":"▲","checkin_date":"▲"}

  }else{
    console.log(store.state.checkin_order)
    order_list.value[store.state.checkin_order] = "▼"
  }
}


// 項目を並び替える
let Sort = function(komoku){ 

  let mode = ""
  if(order_list.value[komoku] == "▲"){
    mode = "DESC"
  } else {
    mode = "ASC"
  }
  console.log(komoku)
  // 親コンポーネントへ、並び替えたい項目と昇順・降順の指定を送る
  emit('call',{cmd:'checkin_order',checkin_order:komoku,checkin_mode:mode,id:route.params.id});
}

let current_page = ref(1)
if(store.state.current_page_check){
  current_page.value = store.state.current_page_check
}

let all_page = ref(Math.ceil(kensu.value / page_read_count.value)) // 全ページ数 全件数 / 読み込み件数でページ数を取得


/* 親コンポーネントに関わる関数 */

 // 全件数と表示件数からページ数を算出
  const getPageList = computed(() => {
    const totalPages = Math.ceil(kensu.value / page_read_count.value);
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  })


  //-------- ページネーション -------------------
  const top     = ()  => { // 1ページ目を送る
                          page_change(1)  }
  const back    = ()  => {
                          let set_page = current_page.value
                            // 現在ページ数から1引いたら0にならない場合はマイナスしてページ数を送る
                            if( (set_page-1 ) != 0){
                              set_page = set_page - 1
                              page_change(set_page)
                            }
                          }
  const page    = (i) => {page_change(i)}
  const forward = ()  => { 
                          // 最後のページを取得
                          let last_page = getPageList.value[getPageList.value.length-1]
                         console.log(current_page.value)
    
                          // 現在のページを取得
                          let set_page = current_page.value
                          // 現在ページ数に1を足しても最大値を超えない場合はプラスしてページ数を送る
                            if((set_page + 1) <= last_page){
                              set_page = set_page + 1
                              page_change(set_page)
                            }
                          }
  const last    = ()  => {
                          
                          // 最後のページを送る
                          page_change(getPageList.value[getPageList.value.length-1])
                        }
            
 // 設定されたページに移動する
  let page_change = function(page){
    console.log(page)
    current_page.value = page

    store.state.current_page_check = page
    read_start.value = (page - 1) * page_read_count.value;
    Checkin_search()

  }
  
  // タブをクリックした後再検索する処理
  let TabChange = function(id){
    current_page.value = 1
    store.state.current_page_check = current_page.value 
    read_start.value = 0
    // 選択したタブに切り替える（タブ側ではv-ifで表示・非表示を制御）
    TabActive.value = id
    TabSelect(id)
    Count_change()
  }

  let TabSelect = function(id){
    // アクティブになるタブを青、非アクティブになるタブを白に変更（事前にtabblue、tabwhiteクラスを用意）
    if(id == 'tab1'){
        tab1.value = "tabblue"
        tab2.value = "tabwhite"
    }else if(id == 'tab2'){
        tab1.value = "tabwhite"
        tab2.value = "tabblue"
    }
   
  }

  // 表示件数を変更する
  let Count_change = function(){
    end_count.value = parseInt(page_read_count.value)+1
    all_page.value = Math.ceil(kensu.value / page_read_count.value)

    current_page.value = 1
    store.state.current_page_check = current_page.value 
    read_start.value = 0

    // 件数変更で表示するデータを変える
    Checkin_search()

  }
  // タブ切り替え、または、表示件数切り替えで再検索
  let Checkin_search = function(){

    console.log(read_start.value)
    console.log(current_page.value)
    
    emit('call',{cmd:'checkin_change',
                id:route.params.id,
                TabActive0:TabActive.value,
                page_read_count0:page_read_count.value,
                read_start0:read_start.value});
  }


  /* コンポーネントの表示に関わる処理 */
  let Return_home = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")

  }
  // パンくずリストのクリックで詳細コンポーネントから検索コンポーネントに戻す
  let Return_list = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
  }

  // パンくずリストのクリックで履歴コンポーネントから詳細コンポーネントに戻す
  let Return_detail = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu/detail/"+route.params.id)
  }

// すべてチェックにチェックしたとき
let all_user_check = function(){
  user_check.value = []
    if(all_check.value == false){
      
      for(let r = 0;r<results.length;r++){
        let result = results[r]
        user_check.value[user_check.value.length] = result.jisseki_id
      }
    }
}

// チェックインの処理
let Checkin_check = function(){

  agency_checkin = ""

  if(user_check.value.length <= 0){
    if(TabActive.value ==  'tab1'){
     alert("チェックインしたいユーザーが選択されていません。")
    } else {
     alert("未チェックインの処理をしたいユーザーが選択されていません。")
    }
  }else{
    for(let c =  0;c<user_check.value.length;c++){
      if(c != 0) agency_checkin += ",";
      agency_checkin += user_check.value[c]
    }
    // まとめてチェックイン
    if(TabActive.value ==  'tab1'){
      message.value = "選択されたユーザー全てをチェックインしますか？";
    } else {
      message.value = "選択されたユーザー全てを未チェックイン状態にしますか？";
    }
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "update_jisseki";
    contentMessage.value = MessageModal
  }

}

// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
  Close_message();//メッセージを表示するウィンドウを閉じる

  // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
  if(message_method.value == "update_jisseki"){
    // 選択されたユーザー全てをチェックインしますか？→OK
    Jisseki_update(TabActive.value)
  }
}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
  message_flag.value = false;
  contentMessage.value = null
}

// 指定した対象全ての実績の状況(2:チェックイン)を更新する
let jisseki_update_error = 0
let Jisseki_update = function(tab){

  let send_array = {
      jisseki_id: agency_checkin,
      checkin_date: '',
      update_user:getUser_email()//更新者（＝ログインユーザーのメールアドレス）
	}

  // tab1:チェックイン  tab2:参加前　チェックインの場合は、チェックイン時間の設定
  if(tab == 'tab1'){
    send_array.jokyo = 2

    // チェックイン時間の取得
    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours() + 9 );
    send_array.checkin_date = set_date

  } else {
    send_array.jokyo = 1
  }

  axios.post(URL + "Jisseki_bulkcheckin",
	  send_array,
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
	.then(response => {
		if(response.data["status"] == 1){
        alert("エラーが発生しました。\n"+response.data["message"])
		}else{
      emit('call',{cmd:'checkin',id:route.params.id});
    }
	})
	.catch(error => {  
    if(jisseki_update_error == 6){
        message.value = error + GlobalData.$axios_error
        message_cat.value = 1;
        message_flag.value = true;
        message_method.value = "update_error";
        contentMessage.value = MessageModal
    }else{
        jisseki_update_error++
        setTimeout(function(){Jisseki_update()},"1000")
    }      
  })

}

/* その他関数の記述 */


let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
//タイムスタンプから日時を取り出す
let Timestamp = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours());

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    }
}
//開催日から日を取り出す
let KaisaiDate = function(kaisaidate){  
    if(kaisaidate != "None" && kaisaidate){
      let set_date = new Date(kaisaidate);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours());

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"
    }else{
      return "ー"
    }
}

// 画面がリサイズされた時にＰＣかスマホかの判断をする
const handleResize = () => {
  isSP.value = window.matchMedia("(max-width: 960px)").matches
}

onMounted(() => {
  // リサイズ監視イベント開始
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  // リサイズ監視のイベントを破棄する(メモリーリーク対応)
  window.removeEventListener('resize', handleResize)
})


let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/18ac0be34f8f8065a9b2ce0d1a8fc973"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}
/* 初期処理 */

TabSelect(TabActive.value)
</script>

<style>
 #tab {
        width: 100%;
        margin: auto;
        border:1px solid #007db9;
    }
  .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

  .tabMenu li {
      list-style:none;
      width: 50%;
      padding: 10px 20px;
      cursor: pointer;
  }

  .tabContents {
    width: 100%;
    padding:0 20px;
    border: 1px solid #007db9;
  }

  .tabContents h2 {
      margin: 0 0 10px 0;
      font-size: 20px;
      font-weight: bolder;
  }

  .tabblue{
      color: #fff;
      background-color: #007db9;
  }
  .tabwhite{
      color: #007db9;
      background-color:#fff ;
  }


#List_button_area{
    width: 100%;
    display: flex;
    justify-content: center;
}

#List_button_area a{
    width: 30%;
    max-width: 200px;
    margin: 10px;
}

.vy-search-result-row-head,.vy-search-result{
 text-align: left; 
}

.vy-search-result-row-a{
  cursor: pointer;
}

.balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : -20px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 320px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 92%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}

#page_area{
  margin:10px 0;
  text-align: center;
  padding: 0 10px;
}
#page_area button{
  margin:0 10px;
  height: 33px;
  padding-top: 0;
  padding-bottom: 0;
}

</style>